import Page from "../../formatting/Page";
import { TitleSection } from "../../formatting/CardSection";
import styled, { css } from "styled-components";
import StandardCard, { StandardUpgradeCard } from "./StandardCard";
import SimpleCard, { SimpleUpgradeCard } from "./SimpleCard";
import { onDesktop } from "../../shared/layout/Breakpoints";
import StaticRoutes from "../../static-pages/StaticRoutes";
import { GetContractUpgradeProductsResponse } from "./ContractTypePage";
import { EditableStatusMessage } from "../status/ContractStatus";
import { ButtonLink } from "@teamscheme/button-link";
import MemberUpgradeText from "./MemberUpgradeText";
import PackageInformation from "./PackageInformation";
import PremiumCard, { PremiumUpgradeCard } from "./PremiumCard";
import { PageCardBackButton } from "../../formatting/PageCard";
import { usePrevUrl } from "../routing/ContractFormRoutes";
import { ContractPath } from "../routing/ContractPath";

export const TypeCardModalContent = styled.div`
  text-align: center;
`;

export const TypeCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${PremiumCard} {
    order: -1;
  }

  ${SimpleCard} {
    order: 1;
  }

  ${({
    theme: {
      spacing: { space8, space16, space32 },
    },
  }) =>
    css`
      margin-bottom: ${space16};

      ${onDesktop`
        flex-direction: row;
        align-items: stretch;
        margin: ${space32} -${space8};

        ${PremiumCard}, ${SimpleCard} {
          order: initial;
        }

        ${SimpleCard}, ${StandardCard}, ${PremiumCard} {
          margin: 0 ${space8};
        }
      `}
    `}
`;

export const UpgradeTermsBox = styled(function (props) {
  return (
    <p {...props}>
      <ButtonLink
        variant="secondary"
        linkTo={StaticRoutes.terms.path}
        target="_blank"
      >
        Vilkår for bruk av NAF Kjøpekontrakt
      </ButtonLink>
    </p>
  );
})`
  margin-bottom: ${({ theme }) => theme.spacing.space32};
`;

export function UpgradeContractFooter() {
  return (
    <>
      <UpgradeTermsBox />
    </>
  );
}

const Wrapper = styled.div`
  max-width: ${8 * 120}px;
  padding: ${({ theme }) => theme.spacing.space16};
`;

export default function SelectTypePage({
  upgrade,
}: {
  upgrade: GetContractUpgradeProductsResponse;
}) {
  const prev = usePrevUrl(ContractPath.type);
  return (
    <Page>
      <Wrapper>
        <p>
          <PageCardBackButton back={prev || undefined} />
        </p>
        <EditableStatusMessage />
        <TitleSection
          title="Få mer ut av kjøpekontrakten!"
          ingress={<MemberUpgradeText />}
        >
          <TypeCardContainer>
            <SimpleUpgradeCard upgrade={upgrade} />
            <StandardUpgradeCard upgrade={upgrade} />
            <PremiumUpgradeCard upgrade={upgrade} />
          </TypeCardContainer>
          <UpgradeContractFooter />
        </TitleSection>
        <PackageInformation complete standard simple />
      </Wrapper>
    </Page>
  );
}
